import { INavigationBlockItemBase } from '@cbridge-tools/navigation-block';
import { IMarkupProfile } from '@cbridge-packages/markup-profile';
import { generateMarkupRoute } from '@cbridge-packages/routing-client-admin';

export const markupProfileAsNavigationItem = (profile: IMarkupProfile): INavigationBlockItemBase => ({
  value: profile.markupProfileId,
  label: profile.markupProfileName,
  href: generateMarkupRoute(profile.markupProfileId),
});
